/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Step2_TitleInputs */

const cs_sreality_step2_title = /** @type {(inputs: Sreality_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Každý makléř jako seller`)
};

const en_sreality_step2_title = /** @type {(inputs: Sreality_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Each broker as a seller`)
};

/**
* | output |
* | --- |
* | "2. Each broker as a seller" |
*
* @param {Sreality_Step2_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_step2_title = /** @type {((inputs?: Sreality_Step2_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Step2_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_step2_title(inputs)
	return cs_sreality_step2_title(inputs)
});